(function () {
  var videos = document.querySelectorAll('[data-autoplay-on-view]');

  if (!videos.length) {
    return;
  }

  function prepareVideo(video) {
    if (video.dataset.userSoundEnabled === 'true') {
      return;
    }

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
  }

  function playVideo(video) {
    prepareVideo(video);

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        // Browsers can still block autoplay in some settings; controls remain visible.
      });
    }
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(prepareVideo);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;

        if (entry.isIntersecting) {
          playVideo(video);
        } else {
          video.pause();
        }
      });
    },
    {
      threshold: 0.45,
    }
  );

  videos.forEach(function (video) {
    prepareVideo(video);
    video.addEventListener('volumechange', function () {
      if (!video.muted && video.volume > 0) {
        video.dataset.userSoundEnabled = 'true';
      }
    });
    observer.observe(video);
  });
})();
